export default __webpack_public_path__ + "static/media/8.b794d223.png";